// extracted by mini-css-extract-plugin
export default {"widgetContainer":"CDEKWidget_widgetContainer__JUu1O","widget":"CDEKWidget_widget__Rrwhi"};